module.exports = __webpack_public_path__ + "06d6eb0f3a3b6a170407acca3734ce51.svg";